/* Velvetta – mobilní doplňky (vanilla, bez závislostí). */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  function isMobile() { return MQ.matches; }

  /* ---------- 1. Výška sticky košíku → --v-sticky-h ---------- */
  function syncStickyHeight() {
    var bar = document.querySelector('.v-sticky');
    var h = 0;
    if (bar && !bar.hidden && getComputedStyle(bar).display !== 'none') h = bar.offsetHeight;
    document.documentElement.style.setProperty('--v-sticky-h', h + 'px');
  }

  function watchSticky() {
    var bar = document.querySelector('.v-sticky');
    if (!bar) return;
    syncStickyHeight();
    if ('MutationObserver' in window) {
      new MutationObserver(syncStickyHeight).observe(bar, {
        attributes: true, attributeFilter: ['hidden', 'style', 'class']
      });
    }
    if ('ResizeObserver' in window) new ResizeObserver(syncStickyHeight).observe(bar);
    window.addEventListener('resize', syncStickyHeight, { passive: true });
    window.addEventListener('orientationchange', function () { setTimeout(syncStickyHeight, 250); });
  }

  /* ---------- 2. Galerie ----------
     Na mobilu je stage full-bleed scroll-snap karusel bez náhledů,
     takže šipky i změna varianty musí scrollovat, ne přepínat třídu. */
  function wireGallery() {
    var gal = document.querySelector('.v-gal');
    if (!gal) return;
    var stage = gal.querySelector('.v-gal__stage');
    var slides = stage ? stage.querySelectorAll('.v-gal__slide') : [];
    if (!slides.length) return;

    function currentIndex() {
      var w = slides[0].getBoundingClientRect().width;
      return w ? Math.round(stage.scrollLeft / w) : 0;
    }
    function scrollToIndex(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
    }

    var prev = gal.querySelector('[data-prev]');
    var next = gal.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function (e) {
      if (!isMobile()) return;
      e.stopImmediatePropagation(); scrollToIndex(currentIndex() - 1);
    }, true);
    if (next) next.addEventListener('click', function (e) {
      if (!isMobile()) return;
      e.stopImmediatePropagation(); scrollToIndex(currentIndex() + 1);
    }, true);

    document.addEventListener('velvetta:variant', function (e) {
      if (!isMobile() || !e.detail || !e.detail.featured_media) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.mediaId) === String(e.detail.featured_media.id)) {
          scrollToIndex(i); return;
        }
      }
    });

    /* Po swipu neotevírat lightbox – rozlišíme tap od tažení. */
    var startX = 0, moved = false;
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; moved = false; }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 8) moved = true;
    }, { passive: true });
    stage.addEventListener('click', function (e) {
      if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
    }, true);
  }

  /* ---------- 3. „Co je v balení“ jako rozbalovací seznam ----------
     Originál má na mobilu řádky s „+“ a oddělovač DÁRKY ZDARMA. */
  function wireEssentials() {
    var sec = document.querySelector('.v-ess');
    if (!sec) return;

    var freeGrid = sec.querySelector('.v-ess__grid--free');
    if (freeGrid && !sec.querySelector('.v-ess__divider')) {
      var label = (sec.querySelector('.v-ess__badge') || {}).textContent || 'ZDARMA';
      var div = document.createElement('div');
      div.className = 'v-ess__divider';
      div.setAttribute('aria-hidden', 'true');
      div.textContent = 'DÁRKY ' + label.trim();
      freeGrid.parentNode.insertBefore(div, freeGrid);
    }

    sec.addEventListener('click', function (e) {
      if (!isMobile()) return;
      var card = e.target.closest('.v-ess__card');
      if (!card) return;
      card.classList.toggle('is-open');
    });

    /* přístupnost: řádky jsou na mobilu interaktivní */
    sec.querySelectorAll('.v-ess__card').forEach(function (c) {
      c.setAttribute('role', 'button');
      c.setAttribute('tabindex', '0');
      c.addEventListener('keydown', function (ev) {
        if (!isMobile()) return;
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); c.classList.toggle('is-open'); }
      });
    });
  }

  /* ---------- 4. iOS autoplay pro UGC videa ---------- */
  function prepareVideos() {
    var vids = document.querySelectorAll('.v-ugc__item video');
    if (!vids.length) return;

    Array.prototype.forEach.call(vids, function (v) {
      v.muted = true; v.defaultMuted = true; v.loop = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  /* ---------- 5. Diagnostika přetečení (jen Theme Editor) ---------- */
  function overflowAudit() {
    if (!document.documentElement.classList.contains('shopify-design-mode')) return;
    setTimeout(function () {
      var vw = document.documentElement.clientWidth;
      if (document.documentElement.scrollWidth <= vw + 1) return;
      var bad = [];
      document.querySelectorAll('body *').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width === 0) return;
        if (r.right > vw + 1 || r.left < -1) {
          if (!el.closest('.v-gal__stage, .v-ugc__track, .v-why__track, .v-press__marquee')) bad.push(el);
        }
      });
      if (bad.length) console.warn('[Velvetta] Horizontalni preteceni:', bad);
    }, 900);
  }

  function init() {
    watchSticky();
    wireGallery();
    wireEssentials();
    prepareVideos();
    overflowAudit();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
